<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition()">
    <v-card elevation="2">
      <v-card-title>
         Dénominations Entreprise
      </v-card-title
      >

      <v-simple-table>
        <tbody>
          <SimpleTr
            v-bind:var="identite"
            data="nature"
            field="libelle"
            prefix="Nature : "
        ></SimpleTr>
        <SimpleTr
            v-bind:var="identite"
            data="denominationUniteLegale"
            field="valeur"
            prefix="Dénomination : "
        ></SimpleTr>
 <SimpleTr
            v-bind:var="identite"
            data="denominationUsuelle1UniteLegale"
            field="valeur"
            prefix="Dénomination 1 : "
        ></SimpleTr>

           <SimpleTr
            v-bind:var="identite"
            data="denominationUsuelle2UniteLegale"
            field="valeur"
            prefix="Dénomination 2 : "
        ></SimpleTr>
 <SimpleTr
            v-bind:var="identite"
            data="denominationUsuelle3UniteLegale"
            field="valeur"
            prefix="Dénomination 3 : "
        ></SimpleTr>
 <SimpleTr
            v-bind:var="identite"
            data="nomUniteLegale"
            field="valeur"
            prefix="Nom : "
        ></SimpleTr>
 <SimpleTr
            v-bind:var="identite"
            data="nomUsageUniteLegale"
            field="valeur"
            prefix="Nom d'usage : "
        ></SimpleTr>
 <SimpleTr
            v-bind:var="identite"
            data="prenom1UniteLegale"
            field="valeur"
            prefix="Prénom 1 : "
        ></SimpleTr>
 <SimpleTr
            v-bind:var="identite"
            data="prenom2UniteLegale"
            field="valeur"
            prefix="Prénom 2 : "
        ></SimpleTr>
 <SimpleTr
            v-bind:var="identite"
            data="prenom3UniteLegale"
            field="valeur"
            prefix="Prénom 3 : "
        ></SimpleTr>
 <SimpleTr
            v-bind:var="identite"
            data="prenom4UniteLegale"
            field="valeur"
            prefix="Prénom 4 : "
        ></SimpleTr>
<SimpleTr
            v-bind:var="identite"
            data="prenom4UniteLegale"
            field="valeur"
            prefix="Prénom 4 : "
        ></SimpleTr>
          <SimpleTr
            v-bind:var="identite"
            data="prenom4UniteLegale"
            field="valeur"
            prefix="Prénom 4 : "
        ></SimpleTr>
          <SimpleTr
            v-bind:var="identite"
            data="prenomUsuelUniteLegale"
            field="valeur"
            prefix="Prénom usuel : "
        ></SimpleTr>
          <SimpleTr
            v-bind:var="identite"
            data="pseudonymeUniteLegale"
            field="valeur"
            prefix="Pseudonyme : "
        ></SimpleTr>
          <SimpleTr
            v-bind:var="identite"
            data="sigleUniteLegale"
            field="valeur"
            prefix="Sigle : "
        ></SimpleTr>

          <SimpleTr
            v-bind:var="identite"
            data="sexeUniteLegale"
            field="valeur"
            prefix="Sexe : "
        ></SimpleTr>

        </tbody>
      </v-simple-table>
      </v-card>
       <v-card elevation="2">
      <v-card-title>
         Dénominations Etablissement
      </v-card-title
      >

      <v-simple-table>
        <tbody>

        <SimpleTr
            v-bind:var="identite"
            data="denominationUsuelleEtablissement"
            field="valeur"
            prefix="Dénomination usuelle : "
        ></SimpleTr>

        <SimpleTr
            v-bind:var="identite"
            data="enseigne1Etablissement"
            field="valeur"
            prefix="Enseigne 1 : "
        ></SimpleTr>
         <SimpleTr
            v-bind:var="identite"
            data="enseigne2Etablissement"
            field="valeur"
            prefix="Enseigne 2 : "
        ></SimpleTr>
         <SimpleTr
            v-bind:var="identite"
            data="enseigne3Etablissement"
            field="valeur"
            prefix="Enseigne 3 : "
        ></SimpleTr>


        </tbody>
      </v-simple-table>
    </v-card>
  </v-col>
</template>

<script>
import SimpleTr from "@/components/layout/SimpleTr.vue";

export default {
  name: "Identite",
  props: ["etablissement"],
  components: {
    SimpleTr,
  },
  computed: {
    identite: function () {
      return this.$store.getters.getbloc("identite", "donnees");
    },
    administratif: function () {
      return this.$store.getters.getbloc("administratif", "donnees");
    },
  },
  methods: {
    condition() {
      return this.$store.getters.condition("identite", "donnees");
    },
    condition_administratif() {
      return this.$store.getters.condition("administratif", "donnees");

    },
  },
};
</script>
